export default "__VITE_ASSET__DPcvFqQU__"